"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedHostGateway = void 0;
const store_1 = require("../shared-state/store");
const events_1 = require("../shared-state/events");
const http_client_1 = require("../http-client");
/** Class for a shared host application gateway instance
 ```
 window.sharedHostGateway = new SharedHostGateway({})
 ```
*/
class SharedHostGateway {
    /**
     * Creation of the instance, should be done once at host app root to avoid synchronous modules load problems.
     * @param GatewayOptions accepted options
     * @param GatewayOptions.httpClient pass this if you want to use specific http client, otherwise defaults to wlabel
     * @param GatewayOptions.logger binds logger instance so its methods could be called through the gateway
     */
    constructor({ httpClient = http_client_1.defaultHttpClient, logger }) {
        this.domains = new Map();
        this.stateSharing = {
            $sharedState: store_1.$sharedState,
            shareValue: events_1.shareValue,
            deleteSharedValue: events_1.deleteSharedValue
        };
        this.httpClient = httpClient;
        this.logger = logger;
    }
    /**
     * Invoke to register a new effector domain and share its content
     * @param {string} domainName assumed unique name of the shared domain inside the instance
     * @param domain Object containing shared functions/units
     * @param domain.selectors selectors providing access to domain's stored information
     */
    registerDomain(domainName, domain) {
        if (this.domains.has(domainName)) {
            throw new Error(`SharedHostGateway Error: domain ${domainName} is already registered`);
        }
        this.domains.set(domainName, domain);
    }
    /**
     *
     * @param {string} domainName domain name which selectors should be returned
     * @returns object containing { selectors }
     */
    getSelectors(domainName) {
        if (!this.domains.has(domainName)) {
            throw new Error(`SharedHostGateway Error: domain ${domainName} not found`);
        }
        const domain = this.domains.get(domainName) || { selectors: {} };
        const { selectors } = domain;
        return selectors;
    }
    /**
     *
     * @param notifications Object containing notification functions to be registered by the host app
     * @param notifications.catchAndNotify Host app function to log and display system errors
     * @param notifications.showNotification Shared functions for widgets to use system notifications
     */
    registerNotifications(notifications) {
        this.notifications = notifications;
    }
    /**
     * @param args unopinionated regarding the arguments, whatever the bound logger supports
     */
    logError(...args) {
        var _a;
        if (!((_a = this === null || this === void 0 ? void 0 : this.logger) === null || _a === void 0 ? void 0 : _a.error)) {
            throw new Error(`SharedHostGateway Error: error logger not found`);
        }
        this.logger.error(...args);
    }
}
exports.SharedHostGateway = SharedHostGateway;
